import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SoftPhoneService {
  constructor() {}

  openPopup(email: string): void {
    const existing = document.getElementById('softphone-iframe-wrapper');
    if (existing) existing.remove();

    const iframeWrapper = document.createElement('div');
    iframeWrapper.id = 'softphone-iframe-wrapper';
    iframeWrapper.style.position = 'fixed';
    iframeWrapper.style.right = '20px';
    iframeWrapper.style.bottom = '20px';
    iframeWrapper.style.width = '400px';
    iframeWrapper.style.height = '600px';
    iframeWrapper.style.zIndex = '10000';
    iframeWrapper.style.border = '1px solid #ccc';
    iframeWrapper.style.borderRadius = '8px';
    iframeWrapper.style.boxShadow = '0 4px 12px rgba(0,0,0,0.3)';
    iframeWrapper.style.backgroundColor = '#fff';
    iframeWrapper.style.overflow = 'hidden';

    // === Drag Header ===
    const dragHeader = document.createElement('div');
    dragHeader.style.height = '30px';
    dragHeader.style.background = '#f2f2f2';
    dragHeader.style.cursor = 'move';
    dragHeader.style.display = 'flex';
    dragHeader.style.alignItems = 'center';
    dragHeader.style.justifyContent = 'space-between';
    dragHeader.style.padding = '0 8px';

    const title = document.createElement('span');
    title.textContent = 'Softphone';
    title.style.fontSize = '14px';
    title.style.color = '#333';

    // === Minimize/Maximize button ===
    const toggleBtn = document.createElement('button');
    toggleBtn.textContent = '—';
    toggleBtn.style.background = 'transparent';
    toggleBtn.style.border = 'none';
    toggleBtn.style.fontSize = '18px';
    toggleBtn.style.cursor = 'pointer';

    let isMinimized = false;
    let prevLeft = '';
    let prevTop = '';

    toggleBtn.addEventListener('click', () => {
      isMinimized = !isMinimized;
      if (isMinimized) {
        // Save current position
        prevLeft = iframeWrapper.style.left;
        prevTop = iframeWrapper.style.top;

        // Reset position to dock
        iframeWrapper.style.left = '';
        iframeWrapper.style.top = '';
        iframeWrapper.style.right = '20px';
        iframeWrapper.style.bottom = '20px';
        iframeWrapper.style.width = '200px';
        iframeWrapper.style.height = '40px';

        iframe.style.display = 'none';
        dragHeader.style.cursor = 'pointer';
        toggleBtn.textContent = '+'; // Maximize icon
      } else {
        // Restore previous position and size
        iframeWrapper.style.width = '400px';
        iframeWrapper.style.height = '600px';

        if (prevLeft && prevTop) {
          iframeWrapper.style.left = prevLeft;
          iframeWrapper.style.top = prevTop;
          iframeWrapper.style.right = '';
          iframeWrapper.style.bottom = '';
        }

        iframe.style.display = 'block';
        dragHeader.style.cursor = 'move';
        toggleBtn.textContent = '—'; // Minimize icon
      }
    });

    dragHeader.appendChild(title);
    dragHeader.appendChild(toggleBtn);

    // === Iframe ===
    const iframe = document.createElement('iframe');
    iframe.src = `https://dialer.mcube.com/email_login.html?email=${encodeURIComponent(email)}`;
    iframe.allow = 'microphone; autoplay';
    iframe.style.width = '100%';
    iframe.style.height = 'calc(100% - 30px)';
    iframe.style.border = 'none';

    // === Drag overlay ===
    const dragOverlay = document.createElement('div');
    dragOverlay.style.position = 'fixed';
    dragOverlay.style.top = '0';
    dragOverlay.style.left = '0';
    dragOverlay.style.width = '100vw';
    dragOverlay.style.height = '100vh';
    dragOverlay.style.zIndex = '9999';
    dragOverlay.style.cursor = 'move';
    dragOverlay.style.display = 'none';
    document.body.appendChild(dragOverlay);

    iframeWrapper.appendChild(dragHeader);
    iframeWrapper.appendChild(iframe);
    document.body.appendChild(iframeWrapper);

    // === Drag logic ===
    let offsetX = 0;
    let offsetY = 0;
    let isDragging = false;

    dragHeader.addEventListener('mousedown', (e: MouseEvent) => {
      if (isMinimized) return; // Prevent drag when minimized

      isDragging = true;
      const rect = iframeWrapper.getBoundingClientRect();

      iframeWrapper.style.left = rect.left + 'px';
      iframeWrapper.style.top = rect.top + 'px';
      iframeWrapper.style.right = '';
      iframeWrapper.style.bottom = '';

      offsetX = e.clientX - rect.left;
      offsetY = e.clientY - rect.top;

      dragOverlay.style.display = 'block';

      document.addEventListener('mousemove', onMouseMove);
      document.addEventListener('mouseup', onMouseUp);
    });

    function onMouseMove(ev: MouseEvent) {
      if (!isDragging) return;
      iframeWrapper.style.left = ev.clientX - offsetX + 'px';
      iframeWrapper.style.top = ev.clientY - offsetY + 'px';
    }

    function onMouseUp() {
      isDragging = false;
      dragOverlay.style.display = 'none';
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseup', onMouseUp);
    }
  }
}
